import {
  setFlagD,
  getFlagD,
  setRSAPuKey,
  getRSAPuKey,
  getToken,
  setToken,
  removeToken,
  removeOperator,
  removeMenus,
  setMenus,
  getMenus,
  setOperator,
  getOperator,
  setVehicles,
  setGasUnit,
  getGasUnit,
} from "@/utils/auth";
import router, { resetRouter } from "@/router";
import store from "@/store";

const state = {
  flagD: getFlagD(),
  rsaPuKey: getRSAPuKey(),
  token: getToken(),
  menus: [], //用户菜单
  operator: {
    OperatorId: 0,
    CompanyId: 0,
    OpeName: "",
    ComName: "",
    Qym: "",
    IsForeign: 0,
    Latitude: 0,
    Longitude: 0,
  },
  //能源类型清单，根据用户登录的信息获取 1 柴油 2 气体机 3 油电 4 气电 5 纯电动 6 燃料电池 ，如果只有一种，就不用显示下拉选择了
  energyTypes: [1,5,6],//1,2,3
  //气体机能耗单位
  gasUnit: getGasUnit()||'kg',//'m3',//m3 默认是kg， 如果要转成m3，kg除以0.7143  m³ m3
};

const mutations = {
  SET_FlagD: (state, key) => {
    state.flagD = key;
  },
  SET_RSAKey: (state, key) => {
    state.rsaPuKey = key;
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_OPERATOR: (state, ope) => {
    state.operator = ope;
    if (ope.OilTypeTotal) {
      state.energyTypes = ope.OilTypeTotal.split(',');
    }
  },
  SET_MENUS: (state, menus) => {
    state.menus = menus;
  },
  SET_GASUNIT: (state, gasUnit)=>{
    state.gasUnit = gasUnit;
  }

};

export function generateAsynMenus(data) {
  var menus = [];
  if (data.menus) {
    //PreMenuID = 0

    var p_menus = data.menus.filter((e) => {
      return e.PreMenuID == 0;
    });
    p_menus.forEach((element) => {
      var children = [];
      var p_children_menus = data.menus.filter((e) => {
        return e.PreMenuID == element.MenuID;
      });

      p_children_menus.forEach((children_element) => {
        var child = {
          MenuID: children_element.MenuID,
          PreMenuID: children_element.PreMenuID,
          path: children_element.RegisterName,
          component: children_element.Meno,
          name: children_element.ModuleName || children_element.MenuName,
          title:  children_element.MenuName,
          alias: children_element.MenuAlias,
          meta: {
            title: children_element.MenuName,
            icon: "icon-icon_top_mall",
          },
        };

        children.push(child);
      });

      var menu = {
        MenuID: element.MenuID,
        PreMenuID: element.PreMenuID,
        path: element.RegisterName,
        component: element.Meno,
        name: element.MenuName,
        alias: element.MenuAlias,
        meta: {
          title: element.MenuName,
          icon: "icon-icon_top_mall",
        },
        children: children,
      };
      menus.push(menu);
    });
  } else {
  }
  return menus;
}

const actions = {
  async resetMenus({ commit }, data) {

    var menus = generateAsynMenus({ menus: data });
    console.log("menus", menus);
    //组织生成菜单树
    commit("SET_MENUS", menus);
    //设置菜单

    //保存到缓存里面

    setMenus(JSON.stringify(data));

    // resetRouter();
    // if (menus.length > 0) {
    const accessRoutes = await store.dispatch(
      "permission/generateRoutes",
      menus
    );

    //清除所有路由
    resetRouter();
    // 动态添加路由
    router.addRoutes(accessRoutes);
  },
  // user login
  login({ commit }, data) {
    //设置token
    // console.log(JSON.stringify(data))
    return new Promise(async (resolve, reject) => {
      console.log("login-begin");
      commit("SET_TOKEN", data.token);
      commit("SET_RSAKey", data.RSAKey);
      commit("SET_FlagD", data.flagD);
      
      commit("SET_OPERATOR", {
        OpeName: data.OPTName,
        OperatorId: data.OperatorID,
        CompanyId: data.CompanyID,
        ComName: data.ComName,
        Qym: data.Qym,
        IsForeign: data.IsForeign,
        Latitude: data.Latitude,
        Longitude: data.Longitude,
        OilTypeTotal: data.OilTypeTotal,
      });

      var menus = generateAsynMenus(data);
      //组织生成菜单树
      commit("SET_MENUS", menus);
      //设置菜单

      //保存到缓存里面
      setToken(data.token);
      setRSAPuKey(data.RSAKey);
      setFlagD(data.flagD);
      setOperator(
        JSON.stringify({
          OpeName: data.OPTName,
          OperatorId: data.OperatorID,
          CompanyId: data.CompanyID,
          ComName: data.ComName,
          Qym: data.Qym,
          IsForeign: data.IsForeign,
          Latitude: data.Latitude,
          Longitude: data.Longitude,
          OilTypeTotal: data.OilTypeTotal,
        })
      );
      setMenus(JSON.stringify(data.menus));

      var tree = {};
      data.vehicles.forEach((element) => {
        element.isChecked = false;
        tree[element.id] = element;
      });
      store.dispatch("app/updateVehicleTree", {
        tree,
        rootId: data.vehicles[0].id,
      });

      store.dispatch("app/updateVehicleData", data.vehicles);

      setVehicles(JSON.stringify(data.vehicles));

      //组织路由

      // resetRouter();
      // if (menus.length > 0) {
      const accessRoutes = await store.dispatch(
        "permission/generateRoutes",
        menus
      );

      // 动态添加路由
      router.addRoutes(accessRoutes);
      // }
      resolve();
      console.log("login-end");
    });
  },

  setGasUnit({commit},unit){
    return new Promise((resolve, reject) => {
      if(!unit||unit == ""){
        unit = "kg";
      }
      commit("SET_GASUNIT", unit);
      setGasUnit(unit);
      resolve();
    })
  },

  // get user info
  getMenuTrees({ commit, state }) {
    return new Promise((resolve, reject) => {
      //从当前的数据获取，没用就从缓存获取，然后写入当前的数据项目
      if (state.menus && state.menus.length > 0) {
        resolve({ menus: state.menus });
      } else {
        var menu_json = getMenus();
        if (menu_json && menu_json != "") {
          var menus = generateAsynMenus({ menus: JSON.parse(menu_json) });
          //组织生成菜单树

          commit("SET_MENUS", menus);

          var opt = getOperator();
          if (opt && opt != "") commit("SET_OPERATOR", JSON.parse(opt));

          resolve({ menus: menus });
        } else {
          reject();
        }
      }
      // getInfo(state.token).then(response => {
      //     const { data } = response

      //     if (!data) {
      //         reject('Verification failed, please Login again.')
      //     }

      //     const { menus, name } = data

      //     // roles must be a non-empty array
      //     if (!menus || menus.length <= 0) {
      //         reject('getInfo: menus must be a non-null array!')
      //     }

      //     commit('SET_MENUS', menus)
      //     commit('SET_NAME', name)
      //     resolve(data)
      // }).catch(error => {
      //     reject(error)
      // })
    });
  },

  // user logout
  logout({ commit, dispatch }) {
    commit("SET_TOKEN", "");
    commit("SET_MENUS", []);
    removeToken();
    removeOperator();
    removeMenus();
    resetRouter();

    dispatch("tagsView/delAllViews", null, { root: true });
    // reset visited views and cached views
    // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485



  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit("SET_TOKEN", "");
      commit("SET_MENUS", []);
      removeToken();
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
